import { Injectable } from "@angular/core";
import { Actions, Effect, ofType } from "@ngrx/effects";
import { OperationHistoryService } from "@edp-services/operation-history.service";
import { EOperationsActions, SetOperations } from "@edp-store/actions/operations.actions";
import { switchMap } from "rxjs/operators";
import { of } from "rxjs";
import { OperationHistoryTemplate } from "@edp-models/operation-history.model";

@Injectable()
export class OperationsEffects {

    @Effect()
    loadPaymentReference$ = this.actions$.pipe(
        ofType(EOperationsActions.GetOperations),
        switchMap(() => this.operationHistoryService.getOperations()),
        switchMap((operations: OperationHistoryTemplate[]) => {
            return of(new SetOperations(operations));
        })
    );

    constructor(
        private actions$: Actions,
        private operationHistoryService: OperationHistoryService,
    ) { }
}
